module.exports = {
      id: "fullscreen-exit-usage",
      viewBox: "0 0 24 24",
      url: "/" + "svg-sprite-21c17c4d458cf2e2be6dd4c01f9ab03b.svg#fullscreen-exit",
      toString: function () {
        return this.url;
      }
    }